<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue';
import { defineProps } from 'vue';
import Empty from '@/components/Empty';
import { useCommonData } from '@/hooks';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

const props = defineProps({
	quarterDetails: {
		type: Object,
		default: () => ({})
	},
	homeStyle: {
		type: Boolean,
		default: true
	}
});

const { proxy } = getCurrentInstance();
const { getUpperThemeColor } = useCommonData();

// 图标列表逻辑
const performanceIconList = ref([]);
watch(
	() => getUpperThemeColor.value,
	color => {
		if (color) {
			const imgList = [
				require(`@/assets/images/home/performance_icon_01.png`),
				require(`@/assets/images/home/performance_icon_02.png`),
				require(`@/assets/images/home/performance_icon_03.png`),
				require(`@/assets/images/home/performance_icon_04.png`)
			];
			performanceIconList.value = imgList;
		}
	},
	{ immediate: true }
);

// 筛选入口列表
const filterEnterList = computed(() => {
	const entryList = [
		{
			label: proxy.$t('enterprise.results-announcement'),
			key: 'announcementLink'
		},
		{
			label: proxy.$t('enterprise.results-summary'),
			key: 'roundupLink'
		},
		{
			label: proxy.$t('enterprise.earnings-library'),
			key: 'showLink'
		},
		{
			label: proxy.$t('enterprise.earnings-calls'),
			key: 'roadshowLink'
		}
	];

	return entryList.filter(entry => !!props.quarterDetails[entry.key]);
});

const { viewModule } = useModuleNavigation();
const handleClick = item => {
	const { announcementLink, roundupLink, showLink, roadshowLink, id } = props.quarterDetails;
	const { key } = item;
	if (key === 'announcementLink') {
		viewModule('quarterly_performance_announcement', { comeinLink: announcementLink, id });
	} else if (key === 'roundupLink') {
		viewModule('quarterly_performance_summary', { comeinLink: roundupLink, id });
	} else if (key === 'showLink') {
		viewModule('quarterly_performance_custom', { comeinLink: showLink, id });
	} else if (key === 'roadshowLink') {
		viewModule('quarterly_performance_roadshow', { roadshowLink, id });
	}
};
</script>

<template>
	<div class="quarter-flex-1 quarter-performance-entry">
		<template v-if="filterEnterList.length">
			<div
				v-for="(item, index) in filterEnterList"
				:key="index"
				:class="['quarter-performance-item', homeStyle && 'quarter-performance-item--white']"
				@click="handleClick(item)"
			>
				<div class="quarter-performance-icon">
					<el-image :src="performanceIconList[index]" style="width: 100%; height: 100%" fit="cover" />
					<MixColorMask />
				</div>
				<div class="quarter-performance-label">{{ item.label }}</div>
			</div>
		</template>
		<div v-else class="quarter-performance-empty" :class="homeStyle && 'quarter-performance-empty--white'">
			<Empty />
		</div>
	</div>
</template>

<style lang="less" scoped>
.quarter {
	&-flex-1 {
		flex: 1;

		& + .quarter-flex-1 {
			margin-left: 96px;
		}
	}
	&-performance {
		&-entry {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			align-content: space-between;
		}
		&-empty {
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;

			&.quarter-performance-empty--white {
				background: #ffffff;
			}
		}
		&-item {
			display: inline-flex;
			justify-content: center;
			align-items: center;
			background: linear-gradient(78.14deg, rgba(248, 250, 255, 0.4) 0%, #eef0f7 100%);
			cursor: pointer;

			&--white {
				background: #fff;
			}

			/* 一个 */
			&:first-child:nth-last-child(1) {
				width: 100%;
				height: 100%;
			}
			/* 两个 */
			&:first-child:nth-last-child(2),
			&:first-child:nth-last-child(2) ~ & {
				width: 100%;
				height: calc(50% - 8px);
			}
			/* 三个 */
			&:first-child:nth-last-child(3),
			&:first-child:nth-last-child(3) ~ & {
				width: calc(50% - 8px);
				height: calc(50% - 8px);
				&:nth-child(3) {
					width: 100%;
				}
			}
			/* 四个 */
			&:first-child:nth-last-child(4),
			&:first-child:nth-last-child(4) ~ & {
				width: calc(50% - 8px);
				height: calc(50% - 8px);
			}
		}
		&-icon {
			width: 64px;
			height: 64px;
			position: relative;
		}
		&-label {
			margin-left: 4px;
			color: #1d2129;
			text-align: center;

			font-size: 20px;

			font-weight: 500;
			line-height: 24px; /* 100% */
		}
	}
}
</style>
